import React, { createContext, useState, useContext } from 'react';

// Create the context
const ProductContext = createContext();

// Provider component
export const ProductProvider = ({ children }) => {
  const [productDetails, setProductDetails] = useState(null); // Memory-only

  return (
    <ProductContext.Provider value={{ productDetails, setProductDetails }}>
      {children}
    </ProductContext.Provider>
  );
};

// Custom hook to use context
export const useProduct = () => useContext(ProductContext);
